import { ref } from 'vue';

export const newStore = {
  modal: ref(false),
  state: ref([]),
  countNotif: ref(0),

  setCount(val) {
    this.countNotif.value = val;
  },

  open() {
    this.modal = true;
  },

  close() {
    this.modal.value = false;
  }
};
